export function isNodeInViewport(node, offset = 0) {
    if (!node || typeof window === 'undefined') {
        return false;
    }
    const { top } = node.getBoundingClientRect();
    return top + offset >= 0 && top - offset <= window.innerHeight;
}

export function getViewportSize() {
    const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    return {
        height,
        width,
    };
}
